import React, { useState, useEffect } from "react";

import MainInstantDetails from "./MainInstantDetails";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import DateRangeComponent from "../../../reuseableComponents/DateRangeComponent";
import { Grid } from "@mui/material";
import InventoryTable from "../InventoryReport/InventoryTable";
import DashDateRangeComponent from "../../../reuseableComponents/InventoryReportDateComponent";
import Config from "../../../Constants/Config";
import axios from "axios";
import { getCurrentDateRange } from "../../../helperFunctions/dataRange";
import { generateCSVDataAndHeaders } from "../../../helperFunctions/csvhelperforTable";
import { useSelector } from "react-redux";
import { PERMISSIONS } from "../../../Constants/permission";

const InstantActvity = ({
  setCSVData,
  setCSVHeaders,
  setExportFilters,
  setExportAvailable,
  setExportHeaders,
}) => {
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
    useAuthDetails();
  const { permissions } = useSelector((state) => state.permissions);
  const hideCosts =
    Array.isArray(permissions) &&
    permissions.length > 0 &&
    permissions.includes(PERMISSIONS.HIDE_COST);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reorderTotal, setReorderTotal] = useState();
  const [page, setPage] = useState(1); // Track current page number
  const [poActivityListData, setPoActivityListData] = useState([]);
  // const [filteredData, setFilteredData] = useState([]);
  const [filteredData, setFilteredData] = useState(getCurrentDateRange());
  const handleDateRangeChange = (dateRange) => {
    setPoActivityListData([]);
    setHasMore(true);
    setPage(1);
    setFilteredData(dateRange);
    if (typeof setExportAvailable === "function") {
      setExportAvailable(false);
    }
    if (typeof setExportFilters === "function") {
      setExportFilters({
        start_date: dateRange?.start_date,
        end_date: dateRange?.end_date,
        search_by: dateRange?.search_by,
        measure_type: "All inventory",
        report_type: "Product",
      });
    }
    fetchProductsData(1, dateRange);
  };

  const fetchProductsData = async (page, dateRange) => {
    setIsLoading(true);
    if (reorderTotal) {
      // console.log("Aborting previous request...");
      reorderTotal.abort();
    }
    let totalCallSignal = new AbortController();
    setReorderTotal(totalCallSignal);
    try {
      setLoading(true);
      const payload = {
        merchant_id: LoginGetDashBoardRecordJson?.data?.merchant_id,
        token_id: LoginGetDashBoardRecordJson?.token_id,
        login_type: LoginGetDashBoardRecordJson?.login_type,
        limit: 10,
        page: page,
        start_date: dateRange.start_date,
        end_date: dateRange.end_date,
        search_by: dateRange.search_by,
      };
      const response = await axios.post(
        `${Config.BASE_URL}${Config.INSTANT_ACTIVITY_REPORT}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${LoginGetDashBoardRecordJson?.token}`,
          },
          signal: totalCallSignal.signal,
        }
      );

      if (!response?.data?.status && response?.data?.page == 1) {
        setPoActivityListData([]);
      }
      const products = response?.data?.result;
      if (typeof setExportAvailable === "function" && page === 1) {
        setExportAvailable(Array.isArray(products) && products.length > 0);
      }
      if (products && products.length < 5) {
        setHasMore(false);
      }
      if (products && products.length > 0 && page == 1) {
        setPoActivityListData(products);
      } else if (products && products.length > 0 && page != 1) {
        setPoActivityListData([...poActivityListData, ...products]);
      }
      if (page > 1 && !products) {
        setHasMore(false);
      }
      setIsLoading(false);
      setLoading(false);
      return products;
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      // setLoading(false);
    }
  };
  const fetchMoreData = () => {
    setPage((prevPage) => prevPage + 1);
    fetchProductsData(page + 1, filteredData);
  };

  // useEffect(() => {
  //   fetchProductsData(page, filteredData);
  // }, []);

  useEffect(() => {
    // if (poActivityListData.length > 0) {
    const headers = [
      { id: "title", name: "Instant PO Info" },
      { id: "emp_name", name: "Source" },
      { id: "current_qty", name: "Before Adjusted Qty" },
      { id: "qty", name: "Adjusted Qty" },
      { id: "after_qty", name: "After Adjusted Qty" },
    ];
    if (!hideCosts) {
      headers.push(
        { id: "price", name: "Cost Per Item " },
        { id: "totalcost", name: "Total Cost" }
      );
    }
    const { CSVData, CSVHeaders } = generateCSVDataAndHeaders(
      poActivityListData,
      headers
    );
    setCSVData(CSVData);
    setCSVHeaders(CSVHeaders);
    if (typeof setExportHeaders === "function") {
      try {
        setExportHeaders(headers.map((h) => h.name));
      } catch (e) {
        // no-op
      }
    }
    // }
  }, [setCSVData, setCSVHeaders, poActivityListData, hideCosts]);
  return (
    <>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <DashDateRangeComponent onDateRangeChange={handleDateRangeChange} />
        </Grid>
      </Grid>
      <MainInstantDetails
        setPoActivityListData={setPoActivityListData}
        instantactivityDataState={poActivityListData}
        scrollForProduct={fetchMoreData}
        hasMore={hasMore}
        loading={loading}
        isLoading={isLoading}
      />
    </>
  );
};

export default InstantActvity;
